import styled from 'styled-components';
import { Box } from '@strapi/design-system/Box';
export const Main = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0.75rem;
  margin-bottom: 1rem;
`;
export const Header = styled(Box)`
  border-radius: 4px 4px 0px 0px;
  display: grid;
  grid-template-columns: 3fr 2fr;
  column-gap: 1rem;
  height: 3.5rem;
  margin-bottom: 1px;
  overflow:  hidden;
  padding: 12px 20px;
  width: 100%;
`;
export const Content = styled(Box)`
  border-radius: 0px 0px 4px 4px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  row-gap: 0.5rem;
`;
export const CloseIcon = styled(Box)`
  align-items: center;
  aspect-ratio: 1 / 1;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 30px;
`;